import axios from 'axios';
import BASEURL from '../BaseUrl';
import { logoutApi } from './AuthApi';

export const getPresignedUrlApi = async ({ path, workflow_id, secretName, expirySeconds = 300, type }) => {
  try {
    const token = JSON.parse(sessionStorage.getItem('jwtToken'));
    if (!token) throw new Error('No token found');

    const response = await axios.get(`${BASEURL}/s3/presigned-url`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params: {
        path,
        workflow_id,
        connectionName: secretName,
        type,
        expirySeconds,
      },
    });

    return response;
  } catch (error) {
    console.error('Error getting presigned URL:', error);
    if (error.response?.status === 401) {
      await logoutApi();
    }
    throw error;
  }
};

export const getPresignedUrlRangeApi = async ({ path, workflow_id, start, end }) => {
  try {
    const token = JSON.parse(sessionStorage.getItem('jwtToken'));
    if (!token) throw new Error('No token found');

    const response = await axios.get(`${BASEURL}/s3/presigned-url/range`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params: {
        path,
        workflow_id,
        start,
        end,
      },
    });

    return response;
  } catch (error) {
    console.error('Error getting presigned URL range:', error);
    if (error.response?.status === 401) {
      await logoutApi();
    }
    throw error;
  }
};
